import router from './index';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { Route } from 'vue-router';
import UserModule from '@/store/modules/user';
import axios from 'axios';
import { Dialog } from 'vant';
// import SessionModule from '@/store/modules/session';

// 白名单，未登录用户可以访问
const whiteList = ['/', '/login', '/logout', '/register', '/setpass', '/news', /\/portal\//i];
function whiteListTest(path: string) {
  return whiteList.some(o => {
    if (o instanceof RegExp) {
      return o.test(path);
    } else {
      return o === path;
    }
  });
}
NProgress.configure({ showSpinner: false }); // NProgress Configuration

function isUserinfo(to: Route, from: Route, next: any) {
  if (to.path.indexOf('/personInfo/editUserInfo') > -1) {
    return true;
  } else {
    if (
      UserModule.info &&
      UserModule.info.name &&
      UserModule.info.birthday &&
      UserModule.info.workUnit &&
      UserModule.info.job
    ) {
      return true;
    } else {
      Dialog({
        message: '请完善个人信息后操作',
        beforeClose: (action, done) => {
          next({
            name: 'editUserInfo',
            query: {
              redirect: from.fullPath,
            },
          });
          done();
        },
      });
    }
  }
}

function jobCheck(to: Route, from: Route, next: any) {
  if (
    to.path.indexOf('/personInfo/editUserInfo') > -1 ||
    (getUrlParam('classId') && getUrlParam('opreateType') && getUrlParam('classType'))
  ) {
    return true;
  } else {
    if (
      UserModule.info?.job &&
      UserModule.info.job != '无' &&
      UserModule.info.job != '暂无' &&
      (UserModule.info?.postRank != null || UserModule.info?.unManageRank != null)
    )
      return true;
    else {
      Dialog({
        message: '请填写正确的职务或者填写职级后操作',
        beforeClose: (action, done) => {
          next({
            name: 'editUserInfo',
            query: {
              redirect: from.fullPath,
            },
          });
          done();
        },
      });
    }
  }
}

/** 全局路由守卫，处理动态权限 */
router.beforeEach((to: Route, from: Route, next: any) => {
  NProgress.start();
  // if (UserModule.getRefreshToken) {
  //   let time = new Date(new Date().getTime() + 300 * 1000); //到期五分钟前刷新
  //   if (UserModule.getExpiresTime && time >= UserModule.getExpiresTime) {
  //     UserModule.RefreshToken();
  //   }
  // }

  if (UserModule.getToken && !['/login'].includes(to.path)) {
    if (UserModule.avatar.length <= 0) {
      if (to.path === '/') {
        next({
          path: '/home',
          query: {
            classId: getUrlParam('classId'),
            opreateType: getUrlParam('opreateType'),
            classType: getUrlParam('classType'),
            authKey: getUrlParam('authKey'),
          },
        });
      } else {
        localStorage.removeItem('user-status');
        UserModule.GetInfo().then(res => {
          if (!UserModule.getToken) {
            UserModule.FedLogOut().then(() => {
              next({
                path: '/',
                query: {
                  classId: getUrlParam('classId'),
                  opreateType: getUrlParam('opreateType'),
                  classType: getUrlParam('classType'),
                  authKey: getUrlParam('authKey'),
                },
              });
            });
          } else if (jobCheck(to, from, next)) {
            // if (isUserinfo(to, from, next)) {
            if (to.path === '/') {
              next({
                path: '/home',
                query: {
                  classId: getUrlParam('classId'),
                  opreateType: getUrlParam('opreateType'),
                  classType: getUrlParam('classType'),
                  authKey: getUrlParam('authKey'),
                },
              });
            } else {
              next({ ...to, replace: true });
            }
            // }
          }
        });
      }
    } else {
      if (jobCheck(to, from, next)) {
        // if (isUserinfo(to, from, next)) {
        if (to.path === '/') {
          next({
            path: '/home',
            query: {
              classId: getUrlParam('classId'),
              opreateType: getUrlParam('opreateType'),
              classType: getUrlParam('classType'),
              authKey: getUrlParam('authKey'),
            },
          });
        } else {
          if (to.path === '/') {
            next({
              path: '/home',
              query: {
                classId: getUrlParam('classId'),
                opreateType: getUrlParam('opreateType'),
                classType: getUrlParam('classType'),
                authKey: getUrlParam('authKey'),
              },
            });
          } else {
            next();
          }
        }
        // }
      }
    }
  } else {
    if (whiteListTest(to.path)) {
      next();
    } else {
      //next(`/login`);
      next(`/login?redirect=${getUrl()}`);
    }
  }
});

router.afterEach(() => {
  NProgress.done();
  // console.log('router.afterEach', router)
});

function getUrl() {
  const url =
    process.env.NODE_ENV === 'development'
      ? '/'
      : 'https://m.gbjygl.gxela.gov.cn/index.html/#/home?' +
        '&classId=' +
        getUrlParam('classId') +
        '&opreateType=' +
        getUrlParam('opreateType') +
        '&classType=' +
        getUrlParam('classType') +
        '&authKey=' +
        getUrlParam('authKey');
  return url;
}

function getUrlParam(key: string) {
  let p = window.location.href.toString().split('?')[1];
  let params = new URLSearchParams(p);
  const value = params.get(key);
  if (value) {
    return value;
  }
  return '';
}
